export default __webpack_public_path__ + "static/media/PublishTick.4e1cdd5d.svg";